import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    searchBlastseq: '',
    fromSeaching: false
  },
  getters: {
  },
  mutations: {
    updateBlastseq(state, newSeq) {
      state.searchBlastseq = newSeq
    },
    changeFromSeaching(state, flag) {
      state.fromSeaching = flag
    }
  },
  actions: {
  },
  modules: {
  }
})
